import OrganizationTicketsPerBranch from "../../../components/organization/reports/daily/OrganizationTicketsPerBranch";
import DailyGeneratedReportPage from "../../../components/reports/DailyGeneratedReportPage";
import { REPORT_TYPE_IDS } from "../../../store/constants";
import { TICKET_SUMMARY_COLUMN_DEFINITIONS } from "../../../store/renderConfig";

const DailyOrganizationTicketsPerBranch = ({ showFilterForm = true, showTitle = 1 }) => (
  <DailyGeneratedReportPage
    reportTypeId={REPORT_TYPE_IDS.daily_organization_tickets_per_branch}
    title="Tickets Per Branch"
    helmetTitle="Daily Organization Tickets Per Branch"
    descriptionKey="TicketsByBranch"
    columnDefinitions={TICKET_SUMMARY_COLUMN_DEFINITIONS}
    defaultSortColumn="total"
    showFilterForm={showFilterForm}
    showTitle={showTitle}
  >
    {({ data, renderConfig, onRenderConfigChange }) => (
      <OrganizationTicketsPerBranch
        data={data}
        renderConfig={renderConfig}
        onRenderConfigChange={onRenderConfigChange}
      />
    )}
  </DailyGeneratedReportPage>
);

export default DailyOrganizationTicketsPerBranch;
